import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import { get } from 'lodash'
import {
  Box,
  Breadcrumbs as MuiBreadcrumbs,
  Typography,
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { Home } from '@material-ui/icons'

export const getPathParts = () =>
  typeof window !== 'undefined'
    ? get(window, 'location.pathname', '')
        .split('/')
        .slice(1, -1)
    : []

export const makePath = (arr, index) =>
  arr.reduce((acc, next, currentIndex) => {
    // eslint-disable-next-line
    if (currentIndex <= index) acc += `/${next}`
    return acc
  }, '')

export const makeLinks = (paths = [], trans) =>
  paths.map((path, i) => (
    <Link
      key={path}
      to={makePath(paths, i)}
      style={{
        color: 'inherit',
        fontSize: '0.833rem',
      }}
    >
      {i === 0 && (
        <Home
          style={{
            height: '1rem',
            marginRight: '.25rem',
            width: '1rem',
          }}
        />
      )}
      {trans(path)}
    </Link>
  ))

const Breadcrumbs = ({ title, ...props }) => {
  const [paths, setPaths] = React.useState([])
  const { t } = useTranslation('labels')

  React.useEffect(() => {
    if (typeof window !== 'undefined')
      setPaths(
        window.location.pathname
          .replace(/\/$/, '')
          .split('/')
          .slice(1, -1)
      )
  }, [])

  return (
    <Box
      display="flex"
      mb={2}
      textAlign="center"
      {...props}
    >
      <MuiBreadcrumbs aria-label="breadcrumb">
        {makeLinks(paths, t)}
        <Typography
          aria-current="page"
          style={{ fontSize: '0.833rem' }}
        >
          {title}
        </Typography>
      </MuiBreadcrumbs>
    </Box>
  )
}

Breadcrumbs.propTypes = {
  title: PropTypes.string.isRequired,
}

export default Breadcrumbs
